import { Injectable } from "@angular/core";
import { combineLatest, Observable } from "rxjs";
import { FormDetailsComponentData } from "../../form-details.model";
import { FormDetailsAdapter, getFormDetailsAppBarActions, getFormDetailsHeaderData } from "../../form-details.data";
import { BrokerStatus } from "@partner/shared/SharedConstants";
import { map } from "rxjs/operators";
import { AccountData as CurrentAccountData } from "../../../../../../../account/domain/model/account.model";
import { AccountFacade } from "../../../../../../../account/domain/+state/account.facade";
import { SubmissionsFacade } from "../../../../../../domain/+state/submissions.facade";
import { AdvisorData } from "common";

@Injectable()
export class NewFormFacade {
  constructor(
    private readonly accountFacade: AccountFacade,
    private readonly submissionsFacade: SubmissionsFacade,
    private readonly adapter: FormDetailsAdapter,
  ) { }

  getComponentData$(): Observable<FormDetailsComponentData> {
    return combineLatest([
      this.accountFacade.getCurrentAccount$(),
      this.submissionsFacade.getAdvisorData$()
    ]).pipe(map(([currentAccount, advisorData]: [CurrentAccountData, AdvisorData]) => ({
      currentAccount,
      advisorData,
      headerData: getFormDetailsHeaderData(BrokerStatus.DRAFT, advisorData),
      appBarActions: getFormDetailsAppBarActions(),
      documentsData: this.adapter.adaptDocumentsSectionData()
    })))
  }
}
